/** Build a color map from data: unique values of color_by_key → color. */
export function buildColorMap(
  data: Record<string, unknown>[],
  colorByKey: string,
  palette: string[],
): Map<string, string> {
  const map = new Map<string, string>();
  const seen = new Set<string>();
  for (const row of data) {
    const val = String(row[colorByKey] ?? '');
    if (!seen.has(val)) {
      map.set(val, palette[seen.size % palette.length]);
      seen.add(val);
    }
  }
  return map;
}
